import {Lightbox} from "@utilities/sal-lightbox/sal-lightbox";
import {shopUtilities, WISHLIST} from "@global/shop-utilities/shop-utilities";
import {breakpoints} from "@utilities/sal-breakpoint/sal-breakpoint";
import {handleDefaultAnchorLinks} from "@global/utilities/anchor-scrolling";

const add2breadcrumb = () => {
    /*
     * Haenge Reference-title an Breadcrump
    */
    const breadcrumbElement = document.querySelector('.breadcrumb .breadcrumb__list');
    if (breadcrumbElement) {
        const productTitle = document.querySelector(productDetail.overviewORdetail + ' h1').innerText;
        breadcrumbElement.innerHTML += '<li class="breadcrumb__item"><span class="breadcrumb__item--current">' + productTitle + '</span></li>';
    }
}

const lightboxOptions = {
    mode: 'gallery',
    breakpointCondition: () => {
        return window.innerWidth >= breakpoints.md;
    },
    gallery: {
        imageLinkClass: 'lightbox',
        galleryClass: 'product-header__slider',
        galleryImageClass: 'global-simple-slider__slider-item',
    },
    lightboxClass: 'sal-lightbox',
    lightboxActiveImage: 'lightbox--active-image',
    noScrollClass: 'no-scroll',
    animationDuration: '250ms'
};

const productDetail = {
    overviewORdetail: '.product-detail',

    init: () => {
        const _productDetail = document.querySelector(productDetail.overviewORdetail);
        if (_productDetail !== null) {
            add2breadcrumb();
        }

        if (document.querySelector(`.global-product-header`) !== null) {

            new Lightbox(lightboxOptions);

            const sampleButton = document.querySelector(".global-product-header__sample-button")
            handleDefaultAnchorLinks(sampleButton ? [sampleButton] : [])
        }

        const wishlistItems = document.querySelectorAll(`.global-product-header .${shopUtilities.options.wishlist.class}`);
        wishlistItems.forEach(item => {
            shopUtilities.registerListeners(item, WISHLIST);
        });

        // Roomdesigner
        if (window.ROOMDESIGNER_DATA && window.ROOMDESIGNER_DATA.data.length > 0) {
            import ('@global/global-elements/global-roomdesigner/global-roomdesigner-utilities'/* webpackChunkName: "roomdesigner" */).then(({globalRoomdesignerUtilities}) => {
                globalRoomdesignerUtilities.init();

                const roomdesignerButtons = document.querySelectorAll('.button[data-roomdesigner]')
                roomdesignerButtons.forEach((btn) => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault()
                        e.stopPropagation() // Prevent external URL tracking

                        let eventData = window.ROOMDESIGNER_DATA;
                        if (btn.dataset['roomdesigner'] === 'combinations') {
                            eventData = Object.assign({}, window.ROOMDESIGNER_DATA, {
                                'selectedDecors': [window.ROOMDESIGNER_DATA.reference.title, ...window.ROOMDESIGNER_DATA.data.map(d => d.title)]
                            });
                        }

                        globalRoomdesignerUtilities.openRoomdesigner(eventData);

                        return false;
                    })
                })
            });
        }
    }
};

export {productDetail};
